import clsx from 'clsx';

export type StickerVariant =
  | 'primaryDark'
  | 'primaryLight'
  | 'secondaryDark'
  | 'secondaryLight'
  | 'neutralDark'
  | 'neutralLight'
  | 'successDark'
  | 'successLight'
  | 'warningDark'
  | 'warningLight'
  | 'boxed';

export interface StickerProps {
  size?: 'xs' | 'sm' | 'md' | 'base' | 'lg' | undefined;
  variant?: StickerVariant;
  children?: React.ReactNode;
  className?: string;
  hasMargins?: boolean;
}

export function Sticker({
  variant = 'neutralDark',
  size = 'base',
  children,
  className = '',
  hasMargins = true,
}: StickerProps) {
  return (
    <span
      className={clsx(
        `px-2 font-semibold whitespace-nowrap inline-block border`,
        {
          'mr-1 mb-1': hasMargins,
          'text-xxs sm:py-1': size === 'xs',
          'text-xxs sm:text-xs sm:py-1 ': size === 'sm',
          'text-xxs sm:text-sm sm:py-1': size === 'base' || size === 'md',
          'text-xl py-2': size === 'lg',
          'bg-primary-50 text-neutral-0 border-primary-50':
            variant === 'primaryDark',
          'bg-primary-40 text-primary-60 border-primary-40':
            variant === 'primaryLight',
          'bg-secondary-50 text-neutral-0 border-secondary-50':
            variant === 'secondaryDark',
          'bg-secondary-40 text-secondary-60 border-secondary-40':
            variant === 'secondaryLight',
          'bg-neutral-80 text-neutral-0 border-neutral-80':
            variant === 'neutralDark',
          'bg-neutral-40 text-neutral-80 border-neutral-40':
            variant === 'neutralLight',
          'bg-success-60 text-neutral-0 border-success-60':
            variant === 'successDark',
          'bg-success-40 text-success-60 border-success-40':
            variant === 'successLight',
          'bg-warning-60 text-neutral-0 border-warning-60':
            variant === 'warningDark',
          'bg-warning-40 text-warning-60 border-warning-40':
            variant === 'warningLight',
          'bg-neutral-0 text-neutral-80 border box-border capitalize':
            variant === 'boxed',
        },
        className
      )}
    >
      {children}
    </span>
  );
}

export default Sticker;
